import React, { useContext, useState } from 'react'
import { FilterContext } from '@/App'
import SpinLoading from '@/components/Common/SpinLoading'
import { IAnimation } from '@/packages/sdk/fu_resource_manager'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import OverflowTooltip from '@/components/Common/OverflowTooltip'
type CloudBundleProps = {
    item: IAnimation
    selectedAnimationPath: string
    loadedBundle: any
    flushIndexedDB: any
    gender: any
    setSelectedAnimationPath: any
}
const CloudBundle = (props: CloudBundleProps) => {
    const {
        item,
        selectedAnimationPath,
        flushIndexedDB,
        loadedBundle,
        gender,
        setSelectedAnimationPath,
    } = props
    const { avatar } = useContext(AvatarContext) as FilterContext<typeof AvatarContext>

    const [loadingBundle, setLoadingBundle] = useState('')

    const checkoutLoad = (paths: string[]): boolean => {
        return paths.every(item => loadedBundle.includes(item))
    }

    async function selectAnimation(animation) {
        setSelectedAnimationPath(animation)
        setLoadingBundle(animation)
        const caseGender = gender.slice(0, 1).toUpperCase() + gender.slice(1).toLowerCase()
        await avatar.setAnimationAsync(
            animation,
            true,
            `GAssets/animation/Asia${caseGender}/common/ani_ptag_a${gender}_huxi.bundle`
        )
        setLoadingBundle('')
        flushIndexedDB()
    }
    return (
        <div
            className={
                'animation-item component'
                + (
                    selectedAnimationPath === item.path
                        ? ' active'
                        : ''
                )
                + (
                    loadedBundle.includes(item.path)
                        || (
                            typeof item.path === 'object'
                            && checkoutLoad(item.path)
                        )
                        || (
                            item.path.includes('none.bundle')
                        )
                        ? ' loaded'
                        : ''
                )
            }
            onClick={() => selectAnimation(item.path)}
        >
            <img className='bundle-icon' src={item.icon_url} alt="" />
            <OverflowTooltip className='component-label' content={item.name} width='60%' />
            {
                item.path === loadingBundle ? (
                    <SpinLoading style={{ position: 'absolute', top: '28%' }} />
                ) : <i className='download-img'></i>
            }
        </div>
    )
}

export default CloudBundle
